import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { PATHWAYS, IMG } from "@/lib/content";

export default function PathwaySelector() {
  return (
    <section className="section-pad" data-testid="home-pathways">
      <div className="container-sp">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12">
          <div>
            <div className="overline">Choose your path</div>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#0D1B2A] mt-3 leading-tight max-w-2xl">
              One page in, and you already know where you fit.
            </h2>
          </div>
          <p className="text-[#4A5568] max-w-md">
            Five entry points mirroring the real decisions international students
            face. Pick yours — or message us if you're not sure yet.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {PATHWAYS.map((p, i) => (
            <motion.div
              key={p.key}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
            >
              <Link
                to={p.href}
                data-testid={`pathway-card-${p.key}`}
                className={`group block h-full rounded-2xl overflow-hidden border transition-all duration-300 ${
                  p.premium
                    ? "bg-[#0D1B2A] text-white border-[#1B2A3D] hover:border-[#D7141A]"
                    : "bg-white text-[#0D1B2A] border-[#EFEEE8] hover:border-[#D7141A]/40"
                }`}
              >
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={IMG[p.image]}
                    alt={p.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  {p.premium && (
                    <span className="absolute top-3 left-3 text-[10px] font-semibold uppercase tracking-[0.2em] bg-[#D7141A] text-white px-2 py-1 rounded-full">
                      Premium
                    </span>
                  )}
                </div>
                <div className="p-7">
                  <h3 className="font-serif text-2xl leading-snug">{p.title}</h3>
                  <p
                    className={`mt-3 text-sm leading-relaxed ${
                      p.premium ? "text-white/70" : "text-[#4A5568]"
                    }`}
                  >
                    {p.blurb}
                  </p>
                  <div
                    className={`mt-6 inline-flex items-center gap-1.5 text-sm font-medium ${
                      p.premium ? "text-[#E5444A]" : "text-[#0D1B2A]"
                    }`}
                  >
                    {p.cta}
                    <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
